export const selectCurrentUser = (state) => state.auth.appUser.pk;
export const selectCurrentUserRole = (state) => state.auth.appUser.role;
export const selectCurrentUserPermissions = (state) => state.auth.appUser.permissions || [];
export const selectGetAppUserStatus = (state) => state.auth.getAppUserStatus;
export const selectGetAppUserError = (state) => state.auth.getAppUserError;
export const selectUserNotifyDestination = (state) => state.auth.appUser.notify_destination;
export const selectUserNotifyDestinationStatus = (state) => state.auth.updateNotifyDestinationStatus;
